import React from "react";
import _ from "lodash";
import { dt_dater } from "../../helpers";
import { countries } from "../../../../../umbilical_tools";

// ========================== TRAIN ==============================
export function getTrainBasicData({ reservation, t }) {
  if (!reservation) return [];

  var output = [
    [
      t("originStation"),
      <div key="originStation">
        {reservation.outbound_origin} <br />(
        {
          countries[
            _.get(reservation, "outbound_origin_station", "").split(":")[0]
          ]
        }
        )
      </div>,
    ],
    [
      t("destinationStation"),
      <div key="destination">
        {reservation.outbound_destination}
        <br />(
        {
          countries[
            _.get(reservation, "outbound_destination_station", "").split(":")[0]
          ]
        }
        )
      </div>,
    ],
    [t("reference"), reservation.reference],
    [t("outbound"), dt_dater(reservation.outbound_departure)],
    [t("passengers"), reservation.guests?.length || 0],
    [
      t("hasReturn"),
      _.get(reservation, "service_data.legs.1.is_return_leg", false)
        ? t("yes")
        : t("no"),
    ],
  ];

  const extraOutput = [
    [t("created"), dt_dater(reservation.created)],
    [
      t("status"),
      reservation.status === "CO"
        ? t("confirmed")
        : reservation.status === "CA"
        ? t("cancelled")
        : t("pending"),
    ],
  ];
  return [...output, ...extraOutput];
}

export function getTrainExtraData({ reservation, t }) {
  if (!reservation) return [];

  const hasFreeCXL = reservation.service_data.cancellation_policies.find(
    (cxl) => cxl.frame_type === "refundable"
  );

  const output = [
    [t("freeCancellationAvailable"), hasFreeCXL ? t("yes") : t("no")],
  ];

  const extraOutput = [
    [
      t("freeCancellationDeadline"),
      hasFreeCXL?.date_to ? dt_dater(hasFreeCXL.date_to) : "N/A",
    ],
  ];
  return reservation.non_refundable ? output : [...output, ...extraOutput];
}

export function getTrainPax({ reservation, t }) {
  if (!reservation) return [];

  return _.get(reservation, "guests", []).map((guest) => [
    [t("type"), guest.guest_type_display],
    [t("title"), guest.guest_title_display],
    [t("firstName"), guest.first_name],
    [t("lastName"), guest.last_name],
    [t("email"), guest.email],
    [t("leadGuest"), guest.group_leader ? <strong>{t("yes")}</strong> : ""],
  ]);
}
